import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import Script from 'next/script'
import FadeLoader from 'react-spinners/FadeLoader';
import { RequestContext } from '../../../../context/RequestContext';
import Image from 'next/image';
import { s3Static } from '../../../../utils/constants';
import { FaAngleRight, FaQuestionCircle, FaStar, FaWhatsapp } from 'react-icons/fa';
import { SystemError } from '../../../error/SystemError';
import Link from 'next/link';
import { getAppSettings } from '../../../../api/app-setting/app-setting';
import { openModal } from '../../../../service/modal-service';
import { AnimatePresence } from 'framer-motion';
import { AirconScope } from './AirconScope';
import { whatsAppDisplay, whatsAppUrl, googleRating, gbpUrl } from 'utils/business-info';

export const AirconRepair = (props) => {
    const setRequestForm = props.setRequestForm
    const setIsQuickBook = props.setIsQuickBook;
    const title = props.title
    // Optional, same pattern as AirconBooking.js. Defaults to a claim that is
    // true on every page this component is used on (10+ aircon fault pages).
    const subtitle = props.subtitle || "Vetted technicians from licensed contractors. Transparent pricing, same-day slots available."
    const heroImage = props.heroImage
    // Optional. Pages whose intent isn't a fault (e.g. installation) relabel the input.
    const inputLabel = props.inputLabel || "What is the problem?"
    const countryName = "Singapore"

    const [ airconProblem, setAirconProblem ] = useState(props.problem)

    const [ waInd, setWaInd ] = useState(false)
    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ serviceType, setServiceType ] = useState("general")
    const [ unit, setUnit ] = useState("")
    const [ unitType, setUnitType ] = useState("")
    const [ cost, setCost ] = useState("")

    const [ isSystemError, setIsSystemError ] = useState(false)
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})  

    const { setRequestCriteria, setRequestDescription } = useContext(RequestContext);

    const confirmBook = (criteria) => {
        setRequestCriteria(criteria)
        setRequestDescription('Aircon Repair')
        setIsQuickBook(true)
        // A quick book is not a custom (picker) booking, whatever came before
        props.setIsCustomBook?.(false)
        // setRequestForm(true)
        openModal(setRequestForm)
    }
    
    const quickBook = (e) => {
        e.preventDefault();
        let criteria = 
            [
                {1: 'Aircon repair (water leaking, not cooling, no power etc.)', criteria: 'Type of service - Aircon repair'},
                {4: airconProblem, criteria: 'Problem - ' + airconProblem}
            ]
        
        confirmBook(criteria)
    }
    
    useEffect(() => {
        setRequestCriteria([])
        setRequestDescription('')
        setIsQuickBook(false)
    }, [setIsQuickBook, setRequestCriteria, setRequestDescription])

    const showHelp = async() => {
        setErrorContent({'header': "Chemical Wash vs Chemical Overhaul", 'body': "Basic Chemical wash is chemical cleaning with minimal dismantling, whereas Chemical Overhaul is a thorough cleaning that may require complete dismantling of the unit. Overhaul is recommended for better cleaning."})
        setIsSystemError(true)
    }

    const fetchAppSetting = useCallback(async() => {
        try {
            const appSettings = await getAppSettings(countryName)
            setWaInd(appSettings.waBusinessInd)
        } catch (error) {
            console.log(error);
        }
    }, [countryName])
    
    useEffect(() => {
        if(!countryName) return

        fetchAppSetting()
    }, [countryName, fetchAppSetting])

    const showJobScope = (serviceType, unitType, unit, cost) => {
        setServiceType(serviceType)
        setUnit(unit)
        setUnitType(unitType)
        setCost(cost)
        openModal(setIsShowJobScope)
    }

    // const videoRef = useRef();
    
    // useEffect(() => {  
    //     videoRef.current.play()
    // }, [])
    
  return (
    <>
        {/* Dead video block removed - it was already commented out and unused. */}
        <div className="-mt-14 relative w-full aspect-21/9 sm:h-170 overflow-hidden">
            <Image
                className='bg-linear-to-br from-slate-800 to-orange-300'
                src={s3Static + heroImage}
                fill
                style={{ objectFit: 'cover' }}
                alt={title}
                priority={true}
                sizes="100vw"
            />
        </div>
        <div id="campaign" className= " relative bg-gray-100 sm:bg-transparent w-full py-2 sm:absolute sm:top-1/2 sm:-translate-y-1/2">
            <div className='pt-6 pb-4 relative max-w-md sm:max-w-xl mx-auto rounded-xl bg-white sm:bg-black/40'>  
                <h1 className='text-2xl sm:text-3xl text-center font-bold uppercase px-2 sm:text-white'>
                    {title}
                </h1>
                {subtitle &&
                    <p className='px-3 pt-2 text-center text-sm text-gray-600 sm:text-white/90'>
                        {subtitle}
                    </p>
                }
                <form className='space-y-4 py-2 text-center pt-6' onSubmit={(e) => quickBook(e)}>
                    <label className='block text-center text-sm font-semibold text-gray-700 sm:text-white'>
                        {inputLabel}
                    </label>
                    <div className='max-w-md mx-auto px-4'>
                        <input
                            type="text"
                            className="px-3 py-3 w-full text-center shadow appearance-none border rounded-xl  focus:outline-none focus:shadow-outline focus:shadow-md focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                            placeholder="mention the aircon brand & problem here" name="airconProblem" value={airconProblem} onChange={(e) => setAirconProblem(e.target.value)}
                            style={{ transition: "all .15s ease" }} required
                        />
                    </div>
                    <div className='text-center pt-3'>
                        <button type='submit' className='text-white py-3 px-6 text-lg rounded-2xl bg-linear-to-tr from-orange-600 to-amber-400 text-center space-y-5'
                            aria-label="Book aircon repair service"
                        >
                            <span>Book Visit</span>
                        </button>
                    </div>
                    <button type="button" onClick={() => showJobScope("repair")} aria-label='How AC repair visit works'>
                        <span className='text-black sm:text-white'>Repair Guide</span><FaAngleRight className='inline text-orange-600 sm:text-white text-lg'/>
                    </button>
                    <a href={gbpUrl} target='_blank' rel='noreferrer'
                        className='flex justify-center items-center gap-1.5 text-black sm:text-white'>
                        <FaStar className='text-yellow-400' />
                        <span className='font-semibold'>{googleRating}</span>
                        <span className='text-sm opacity-80'>Google Rating</span>
                    </a>
                    <div className='flex justify-center items-center text-white px-2'>
                        <a
                            href={`${whatsAppUrl}?text=${encodeURIComponent("Hi, I'd like to book aircon repair service.")}`}
                            target='_blank'
                            rel='noreferrer'
                            aria-label='WhatsApp StringsSG to book aircon repair service'
                            className='flex items-center gap-2 bg-linear-to-tr from-green-700 to-green-500 text-white text-sm font-bold px-5 py-2.5 rounded-full shadow-lg'
                        >
                            <FaWhatsapp className='text-base' />
                            WhatsApp {whatsAppDisplay}
                        </a>
                    </div>
                </form>  
            </div>
        </div>
        {isShowJobScope &&
            <AnimatePresence>
                <AirconScope 
                setIsShowJobScope={setIsShowJobScope}
                serviceType={serviceType} 
                unit={unit} 
                unitType={unitType} 
                cost={cost} />
            </AnimatePresence>
        }
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
    </>
  )
}
